/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useContext, useEffect, useState } from 'react';
import DashNavbar from '../../navbar/Navbar';
import DashMenu from '../../menu/DashMenu';
import DashFooter from '../../footer/DashFooter';
import { GlobalState } from '../../../../../globalState';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Ensure you import the CSS
import i18n from '../../../../../i18n';
import { useTranslation } from 'react-i18next';
import { appAddress } from '../../../../../App';

export default function AddMemberTeam() {
  const {t} = useTranslation()

  const state = useContext(GlobalState);
  const [teamMember, setTeamMember] = useState('');
  const [teamMemberPersian, setTeamMemberPersian] = useState('');
  const [teamMemberArabic, setTeamMemberArabic] = useState('');
  const [positionMember, setPositionMember] = useState('');
  const [positionMemberPersian, setPositionMemberPersian] = useState('');
  const [positionMemberArabic, setPositionMemberArabic] = useState('');
  const [imagePreview, setImagePreview] = useState(null);
  const [token] = useSelector(state => state.token);
  const [callback, setCallback] = state.TeamAPI.callback;


  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(savedLanguage);

    const rootElement = document.getElementById('root');
    if (savedLanguage === 'fa' || savedLanguage === 'ar') {
      rootElement.classList.remove('ltr', 'text-left');
      rootElement.classList.add('rtl', 'text-right');
    } else {
      rootElement.classList.remove('rtl', 'text-right');
      rootElement.classList.add('ltr', 'text-left');
    }
  }, []);

  const createTeamMember = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('name', teamMember);
      formData.append('pName', teamMemberPersian);
      formData.append('aName', teamMemberArabic);
      formData.append('position', positionMember);
      formData.append('pPosition', positionMemberPersian);
      formData.append('aPosition', positionMemberArabic);
      formData.append('image', e.target.image.files[0]);

      const res = await axios.post(`${appAddress}/api/team`, formData, {
      // const res = await axios.post('/api/team', formData, {
        headers: { Authorization: token }
      });

      toast.success(res.data.msg, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      
      setTeamMember('');
      setTeamMemberPersian('');
      setTeamMemberArabic('');
      setPositionMember('');
      setPositionMemberPersian('');
      setPositionMemberArabic('');
      setImagePreview(null);
      setCallback(!callback);

    } catch (err) {
      toast.error(err.response.data.msg, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    } else {
      setImagePreview(null);
    }
  }

  const handleRemoveImage = () => {
    setImagePreview(null);
    document.getElementById('imageInput').value = null; // Clear the file input
  }

  return (
    <div className='bg-[#2a3447] text-teal-50 ltr '>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <DashNavbar />
      <div className='flex'>
        <div className='w-[250px] p-5 border-r-4 ltr mt-14'>
          <DashMenu />
        </div>
        <div className='p-4 w-[100%] flex flex-col items-center font-englishTitle'>
          <h2 className='mt-16  text-2xl'>{t("NewTeamMember")}</h2>
          <hr className='bg-slate-500 w-[15%] h-[3px] mb-2 mt-2' />
          <form onSubmit={createTeamMember} encType="multipart/form-data" className=' w-[60%] h-[90%] mt-5 flex flex-col gap-8 justify-center items-center border border-slate-500'>
            <div className='flex flex-col items-center justify-center gap-2 '>
                <input
                id="imageInput"
                className='mt-6 mb-4 p-1 w-[80%] text-slate-900 text-center rounded-md bg-slate-100'
                type="file"
                name="image"
                accept="image/*"
                onChange={handleImageChange}
                required
                />
                {imagePreview && (
                <div className='relative mt-6 mb-4 w-[400px] h-[300px] border border-slate-500 rounded'>
                    <img src={imagePreview} alt="Image Preview" className='w-[100%] h-[300px]' />
                    <button type="button" onClick={handleRemoveImage} className='absolute w-[30px] top-1 right-2 bg-red-500 text-white rounded-full p-1 m-1 hover:bg-red-700'>
                    X
                    </button>
                </div>
                )}
            </div>
            <div className=' grid grid-cols-3 gap-3 w-[90%] justify-center items-center'>
              {/* english */}
            <div className='flex flex-col gap-4 w-[100%] justify-center items-center border border-slate-600'>
              <h5 className='mt-5 text-slate-300'>{t("English")}</h5>
                <input
                    required
                    className='mt-6 mb-4 p-1 w-[90%] text-slate-900 text-center rounded-md'
                    type="text"
                    name='team'
                    value={teamMember}
                    placeholder={t("FullName")}
                    onChange={e => setTeamMember(e.target.value)}
                />
                <input
                    required
                    className='mt-6 mb-4 p-1 w-[90%] text-slate-900 text-center rounded-md'
                    type="text"
                    name='team'
                    value={positionMember}
                    placeholder={t("Position")}
                    onChange={e => setPositionMember(e.target.value)}
                />
            </div>

            {/* persian */}
            <div className='flex flex-col gap-4 w-[100%] justify-center items-center border border-slate-600'>
              <h5 className='mt-5 text-slate-300'>{t("Persian")}</h5>
                <input
                    required
                    className='mt-6 mb-4 p-1 w-[90%] text-slate-900 text-center rounded-md'
                    type="text"
                    name='team'
                    value={teamMemberPersian}
                    placeholder={t("FullName")}
                    onChange={e => setTeamMemberPersian(e.target.value)}
                />
                <input
                    required
                    className='mt-6 mb-4 p-1 w-[90%] text-slate-900 text-center rounded-md'
                    type="text"
                    name='team'
                    value={positionMemberPersian}
                    placeholder={t("Position")}
                    onChange={e => setPositionMemberPersian(e.target.value)}
                />
            </div>

            {/* arabic */}
            <div className='flex flex-col gap-4 w-[100%] justify-center items-center border border-slate-600'>
              <h5 className='mt-5 text-slate-300'>{t("Arabic")}</h5>
                <input
                    required
                    className='mt-6 mb-4 p-1 w-[90%] text-slate-900 text-center rounded-md'
                    type="text"
                    name='team'
                    value={teamMemberArabic}
                    placeholder={t("FullName")}
                    onChange={e => setTeamMemberArabic(e.target.value)}
                />
                <input
                    required
                    className='mt-6 mb-4 p-1 w-[90%] text-slate-900 text-center rounded-md'
                    type="text"
                    name='team'
                    value={positionMemberArabic}
                    placeholder={t("Position")}
                    onChange={e => setPositionMemberArabic(e.target.value)}
                />
            </div>
            </div>
            <button type='submit' className=' text-white hover:text-white bg-green-700 hover:bg-slate-900 w-[20%] mt-5 rounded-xl'>{t("submit")}</button>

          </form>
        </div>
      </div>
      <div className='p-1 mt-16'>
        <DashFooter />
      </div>
    </div>
  )
}
